module.exports = __webpack_public_path__ + "img/file.0029d6a8.svg";